exports.Translate = {
    pageTitle:{
        "/th/th/": "อาหารเดลิเวอรี่ใน",
        "/id/id/": "Pesan Antar Makanan ",
        "/id/": "Food Delivery in ",
        "/sg/": "Food Delivery in ",
        "/": "Food Delivery in ",
        "/th/": "Food Delivery in "
    },
    pageText:{
        "/th/th/": "สำรวจร้านอาหารในย่านใกล้คุณ",
        "/id/id/": "Temukan makanan terbaik di kota anda ",
        "/id/": "Explore good food in your city ",
        "/sg/": "Explore good food in your area ",
        "/": "Explore good food in your city ",
        "/th/": "Explore good food in your city "
    },
    InternalLinkingBlockTitle:{
        "/th/th/": "อาหารเดลิเวอรี่ออนไลน์ใน",
        "/id/id/": "Pesan Antar Makanan Online di ",
        "/id/": "Online Food Delivery in ",
        "/sg/": "Online Food Delivery in ",
        "/": "Online Food Delivery in ",
        "/th/": "Online Food Delivery in "
    },
    thaiCityName: {
        "bang-bo":"บางบ่อ",
        "ban-mai":"บ้านใหม่",
        "bang-kaeo":"บางแก้ว",
        "bang-muang":"บางม่วง",
        "bang-nam-chuet":"บางน้ำจืด",  
        "bang-phriang":"บางบ่อ",
        "bang-sue":"บางซื่อ",
        "chang-wat-pathum-thani":"ปทุมธานี",
        "chang-wat-samut-prakan":"ปากน้ำ",
        "chom-thong":"จอมทอง",
        "khlong-nueng":"ตำบลคลองหนึ่ง",
        "khlong-toey":"คลองเตย",
        "lahan":"ละหาร",
        "na-di":"นาดี",
        "nang-lae":"นางแล",
        "sathon":"สาทร",
        "thepharak":"เทพารักษ์",
        "bang-bua-thong":"บางบัวทอง",
        "bang-chak":"บางจาก",
        "bang-chalong":"บางโฉลง",
        "bang-duan":"บางด้วน",
        "bang-hua-suea":"บางหัวเสือ",
        "bang-kapi":"บางกะปิ",
        "bang-khanun":"บางขนุน",
        "bang-khayaeng":"บางขะแยง",
        "bang-khru":"บางครุ",
        "bang-khu-wat":"บางคูวัด",
        "bang-khu-wiang":"บางคูเวียง",
        "bang-khun-kong":"บางขุนกอง",
        "bang-krang":"บางกร่าง",
        "bang-kruai":"บางกรวย",
        "bang-mae-nang":"บางแม่นาง",
        "bang-mueang-mai":"บางเมืองใหม่",
        "bang-phai":"บางไผ่ ",
        "bang-phlap":"บางพลับ",
        "bang-phli-yai":"บางพลีใหญ่",
        "bang-phueng":"บางพึ่ง", 
        "bang-phun":"บางพูน",
        "bang-pla":"บางปลา",
        "bang-prong":"บางโปรง",
        "bang-pu-mai":"บางปูใหม่",
        "bang-rak":"บางรัก",
        "bang-rak-noi":"บางรักน้อย",
        "bang-rak-phatthana":"บางรักพัฒนา",
        "bang-rak-yai":"บางรักใหญ่",
        "bang-sao-thong":"บางเสาธง",
        "bang-si-thong":"บางสีทอง",
        "bang-tanai":"บางตะไนย์",
        "bangkok":"กรุงเทพมหานคร",
        "bueng-kham-phroi":"บึงคำพร้อย",
        "bueng-kum":"บึงกุ่ม",
        "bueng-yitho":"บึงยี่โถ",
        "chana-songkhram":"ชนะสงคราม",
        "chang-wat-nonthaburi":"จังหวัดนนทบุรี",
        "chang-wat-pathum-thani":"ปทุมธานี",
        "chatuchak":"จตุจักร",
        "chatujak":"จตุจักร",
        "din-daeng":"ดินแดง",
        "don-muang-international-airport":"สนามบินดอนเมือง",
        "don-mueang":"ดอนเมือง",
        "huai-khwang":"ห้วยขวาง",
        "jatujak":"จตุจักร",
        "khlong-phra-udom":"คลองพระอุดม",
        "khlong-san":"คลองสาน",
        "khu-khot":"คูคต",
        "klongtonsai":"คลองต้นไทร",
        "krathum-lom":"กระทุ่มล้ม",
        "krung-thep-maha-nakhon":"กรุงเทพมหานคร",
        "lak-hok":"หลักหก",
        "lam-luk-ka":"ลำลูกกา",
        "lam-phak-kut":"ลำผักกูด",
        "lam-pho":"ลำโพ",
        "lat-phrao":"ลาดพร้าว",
        "lat-sawai":"ลาดสวาย",
        "maha-sawat":"มหาสวัสดิ์",
        "na-mai":"หน้าไม้",
        "nai-khlong-bang-pla-kot":"ในคลองบางปลากด",
        "nong-khaem":"หนองแขม",
        "nonthaburi":"นนทบุรี",
        "om-kret":"อ้อมเกร็ด",
        "on-nut":"อ่อนนุช",
        "pak-khlong-bang-pla-kot":"ปากคลองบางปลากด",
        "pak-kret":"ปากเกร็ด",
        "pathum-wan":"ปทุมวัน",
        "phanthai-norasing":"พันท้ายนรสิงห์",
        "phaya-thai":"พญาไท",
        "phimon-rat":"พิมลราช",
        "phra-nakhon":"พระนคร",
        "phraek-sa-mai":"แพรกษาใหม่",
        "plai-bang":"ปลายบาง",
        "pom-prap-sattru-phai":"ป้อมปราบศัตรูพ่าย",
        "racha-thewa":"ราชาเทวะ",
        "rangsit":"รังสิต",
        "ratchathewi":"ราชเทวี",
        "sai-ma":"สายไหม",
        "salaya":"ศาลายา",
        "samrong-klang":"สำโรงกลาง",
        "samrong-nuea":"สำโรงเหนือ",
        "samsen-nai":"สามเสนใน",
        "samut-prakan":"สมุทรปราการ",
        "samutprakan":"สมุทรปราการ",
        "sao-thong-hin":"เสาธงหิน",
        "sisa-chorakhe-noi":"ศีรษะจรเข้น้อย",
        "sisa-chorakhe-yai":"ศีรษะจรเข้ใหญ่",
        "song-khanong":"ทรงคนอง",
        "suan-luang":"สวนหลวง",
        "suvarnabhumi-airport":"สนามบินสุวรรณภูมิ",
        "thai-ban":"ท้ายบ้าน",
        "thai-ban-mai":"ท้ายบ้านใหม่",
        "wang-thonglang":"วังทองหลาง",
        "wat-chalo":"วัดชลอ",
        "watthana":"วัฒนา",
        "bang-bon":"บางบอน",
        "bang-kho-laem":"บางคอแหลม",
        "bang-khun-thian":"บางขุนเทียน",
        "bang-na":"บางนา",
        "bang-phli":"บางพลี",
        "khlong-toei":"คลองเตย",
        "lat-krabang":"ลาดกระบัง",
        "mueang-samut-prakan":"อำเภอเมืองสมุทรปราการ",
        "phra-khanong":"พระโขนง",
        "phra-pradaeng":"พระประแดง",
        "phra-samut-chedi":"พระสมุทรเจดีย์",
        "prawet":"ประเวศ",
        "rat-burana":"ราษฎร์บูรณะ",
        "saphan-sung":"สะพานสูง",
        "thon-buri":"ธนบุรี",
        "thung-khru":"ทุ่งครุ",
        "yan-nawa":"ยานนาวา",
        "samphanthawong":"สัมพันธวงศ์",
        "bang-khae":"บางแค",
        "bang-khen":"บางเขน",
        "bang-phlat":"บางพลัด",
        "bang-yai":"บางใหญ่",
        "bangkok-noi":"บางกอกน้อย",
        "bangkok-yai":"บางกอกใหญ่",
        "dusit":"ดุสิตธานี",
        "khan-na-yao":"คันนายาว",
        "khlong-sam-wa":"คลองสามวา",
        "lak-si":"หลักสี่",
        "min-buri":"มีนบุรี",
        "mueang-nonthaburi":"เมืองนนทบุรี",
        "nong-chok":"หนองจอก",
        "phasi-charoen":"ภาษีเจริญ",
        "sai-mai":"สายไหม",
        "sai-noi":"ไทรน้อย",
        "taling-chan":"ตลิ่งชัน",
        "thawi-watthana":"ทวีวัฒนา"
    },
    indoCityName: {
        "depok":"Depok",
        "bekasi":"Bekasi",
        "serang":"Serang",
        "south-tangerang":"Tangerang Selatan",
        "jakarta":"Jakarta",
        "west-jakarta":"Jakarta Barat",
        "east-jakarta":"Jakarta Timur",
        "central-jakarta":"Jakarta Pusat",
        "north-jakarta":"Jakarta Utara",
        "south-jakarta":"Jakarta Selatan",
        "tangerang":"tangerang",
        "bogor":"bogor"
    }

    // layoutLabel:{
    //     "/th/th/": "อาหาร",
    //     "/id/id/": "Makanan ",
    //     "/id/": "Food ",
    //     "/sg/": "Food",
    //     "/": "Food",
    //     "/th/": "Food"
    // },
}